import * as yup from "yup";

export const onboardBrandSchema = yup.object({
    name                : yup.string().trim().required("Brand name is required"),
    country             : yup.string().trim().required("Country is required"),
    payment_model       : yup.string().required("Payment model is required"),
    debit_note_frequency: yup.string().required("Debit note frequency is required"),
    platform_name       : yup.string().required("Platform is required"),
    kyc_window          : yup
        .number()
        .typeError("KYC window must be a number")
        .integer("KYC window must be a whole number of days")
        .positive("KYC window must be greater than 0")
        .required("KYC window is required")
});

export const onboardBrandDefaults = {
    name                : "",
    country             : "India",
    payment_model       : "managed_payout",
    debit_note_frequency: "monthly",
    platform_name       : "trackier",
    kyc_window          : 30,
    smtp_host           : "",
    smtp_port           : "587",
    smtp_user           : "",
    smtp_pass           : ""
};

// Mirrors the 4-step flow from the Nook Pay Hub reference (ops.brands.new.tsx):
// Basics -> Platform -> Compliance -> Review.
export const ONBOARD_STEPS = [
    { label: "Basics", fields: ["name", "country", "payment_model", "debit_note_frequency"] },
    { label: "Platform", fields: ["platform_name", "kyc_window"] },
    { label: "Compliance", fields: [] },
    { label: "Review", fields: [] }
];
